module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/icon_arrow_slide-a614e56490197492de64d43aeb76c317.svg";